import { Component, Input } from '@angular/core';

@Component({
  selector: 'ticketing-cross-btn',
  templateUrl: './cross-btn.component.html',
  styleUrls: ['./cross-btn.component.scss']
})
export class CrossBtnComponent {
  @Input() variant: 'white' | 'red' | 'gris' = 'gris'
}
